import React, { useEffect } from 'react';
import './ConfirmModal.css';

function ConfirmModal({
  isOpen,
  message = 'Are you sure?',
  confirmText = 'Confirm',
  confirmVariant = 'danger', // 'danger' | 'primary'
  showCancel = true,
  cancelText = 'Cancel',
  onConfirm,
  onCancel
}) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (showCancel && onCancel) {
          onCancel();
        } else if (onConfirm) {
          onConfirm();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel, onConfirm, showCancel]);

  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-card">
        <p className="confirm-modal-question">{message}</p>
        
        <div className="confirm-modal-buttons-row">
          {showCancel && (
            <button
              type="button"
              className="button button-secondary confirm-modal-btn"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button
            type="button"
            className={`button button-${confirmVariant} confirm-modal-btn`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
